import store from '../react/redux/store/store';
import * as windowActions from '../react/redux/actions/windowSize';
import * as windowFocusActions from '../react/redux/actions/windowFocus';

export default class WindowSize {
	static changeFunctions = new Set();
	static sizeBreakpoints = {
		large: 1318, // Icons get spelled out
		//medium: 924, // When chat can be oocked
		medium: 992, // When chat can be oocked --- Updated to match bootstrap...?!
		small: 768,
	};
	static width = 0;
	static height = 0;

	static onChange(newFunction) {
		WindowSize.changeFunctions.add(newFunction);
	}

	static offChange(newFunction) {
		WindowSize.changeFunctions.delete(newFunction);
	}

	static _visibilityChangeHappened() {
		store.dispatch(windowFocusActions.windowVisibilityChanged(document.visibilityState === 'visible'));
	}

	static _focusChangeHappened(focus) {
		store.dispatch(windowFocusActions.windowFocusChanged(focus));
	}

	static _changeHappened(forceUpdate = false) {
		store.dispatch(windowActions.windowSizeChanged(WindowSize.calculateWindowSizeState(), forceUpdate));
		WindowSize.changeFunctions.forEach(WindowSize._executeChangeFunction);
	}

	static forceUpdate() {
		WindowSize._changeHappened(true);
	}

	static calculateWindowSizeState() {
		WindowSize.width = window.innerWidth;
		WindowSize.height = window.innerHeight;

		const update = {
			windowSizeIsTiny: WindowSize.isTiny(),
			windowSizeIsSmall: WindowSize.width >= WindowSize.sizeBreakpoints.small && WindowSize.width < WindowSize.sizeBreakpoints.medium,
			windowSizeIsMedium: WindowSize.width >= WindowSize.sizeBreakpoints.medium && WindowSize.width < WindowSize.sizeBreakpoints.large,
			windowSizeIsLarge: WindowSize.width >= WindowSize.sizeBreakpoints.large,
		};
		if(WindowSize.height < 160) {
			update.windowSizeIsShort = true;
		}
		else {
			update.windowSizeIsShort = false;
		}

		return update;
	}

	static _executeChangeFunction(changeFunction) {
		changeFunction(WindowSize.width, WindowSize.height);
	}

	static isCompact() {
		return WindowSize.isTiny();
	}

	static isTiny() {
		return WindowSize.width < WindowSize.sizeBreakpoints.small;
	}

	static isMediumOrSmaller = () => {
		return WindowSize.width < WindowSize.sizeBreakpoints.medium;
	};

	static isLarge() {
		return WindowSize.width >= WindowSize.sizeBreakpoints.large;
	}

	static isMediumOrLarger() {
		return WindowSize.width >= WindowSize.sizeBreakpoints.medium;
	}
}
document.addEventListener("visibilitychange", WindowSize._visibilityChangeHappened);
window.onblur = function() {
	WindowSize._focusChangeHappened(false);
};
window.onfocus = function() {
	WindowSize._focusChangeHappened(true);
};
(function() {
		const throttle = function(type, name, obj = window) {
			let running = false;
			const func = function() {
				if(running) {
					return;
				}
				running = true;
				requestAnimationFrame(function() {
					obj.dispatchEvent(new CustomEvent(name));
					running = false;
				});
			};
			obj.addEventListener(type, func);
		};

		/* init - you can init any event */
		throttle('resize', 'optimizedResize', window);

		window.addEventListener('optimizedResize', WindowSize._changeHappened);
	}
)
();